import { useContext } from 'react'
import { UserContext } from 'src/contexts/User'
import { UserPermissionsEnum } from 'src/models/user'

export const usePermissions = (): UserPermissionsEnum[] => {
  const { currentUser } = useContext(UserContext)

  return currentUser?.permissions || []
}
